import { render } from "./cpt-data.vue?vue&type=template&id=39bd442b"
import script from "./cpt-data.vue?vue&type=script&lang=js"
export * from "./cpt-data.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__